import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Widget, WidgetMap } from '../../../models/widget';
import { DragulaService } from 'ng2-dragula';
import { CreateMapModalComponent } from '../create-map-modal/create-map-modal.component';
import { WidgetService } from '../../widget.service';
import { WidgetMapService } from '../../widget-map.service';
import { ModalService } from '../../../core/modal.service';
import { MoveMapModalComponent } from '../../move-map-modal/move-map-modal.component';
import { EditMapModalComponent } from '../edit-map-modal/edit-map-modal.component';

function hasSomeParentTheClass(element, classname) {
  if (element.classList && element.classList.contains(classname)) return true;
  return element.parentNode && hasSomeParentTheClass(element.parentNode, classname);
}

@Component({
  selector: 'cw-widget-map-list',
  templateUrl: './map-list.component.html',
  styleUrls: ['./map-list.component.scss']
})

export class MapListComponent implements OnInit, OnDestroy {
  @Input() widget: Widget;
  @Input() maps: WidgetMap[];
  @Output() orderChanged: EventEmitter<WidgetMap[]> = new EventEmitter<WidgetMap[]>();
  @Output() mapAdded: EventEmitter<WidgetMap> = new EventEmitter<WidgetMap>();
  @Output() mapDeleted: EventEmitter<WidgetMap> = new EventEmitter<WidgetMap>();
  isEditingMaps: boolean = false;
  private busyMap: WidgetMap;

  constructor(private dragulaService: DragulaService,
              private widgetService: WidgetService,
              private mapService: WidgetMapService,
              private modal: ModalService) {
    dragulaService.setOptions('maps', {
      moves: function (el, container, handle) {
        console.log(handle);
        return hasSomeParentTheClass(handle, 'map-list-item-drag'); // handle.classList.contains('map-list-item-drag') || handle.parentNode.classList.contains('map-list-item-drag');
      }
    });

    dragulaService.dropModel.subscribe((value) => {
      this.orderChanged.emit(this.maps);
    });
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.dragulaService.destroy('maps');
  }

  isBusy(map: WidgetMap) {
    return this.busyMap && map === this.busyMap;
  }

  replaceImage(map: WidgetMap) {
    const modalRef = this.modal.open(CreateMapModalComponent);
    modalRef.componentInstance.init(this.widget, map);
    modalRef.result.then(map => {
      this.mapAdded.emit(map);
    });
  }

  processImages(map: WidgetMap) {
    this.mapService.processImages(map).subscribe(() => {

    });
  }

  moveMap(map: WidgetMap) {
    const modalRef = this.modal.open(MoveMapModalComponent);
    modalRef.componentInstance.init(this.widget, map);
    modalRef.result.then(map => {
      this.mapDeleted.emit(map);
    });
  }

  removeMap(map: WidgetMap) {
    if (!confirm('Ta bort kartan? Detta kan inte ångras')) {
      return
    }


    this.busyMap = map;
    this.mapService.delete(map).subscribe(() => {
      this.mapDeleted.emit(map);
      this.busyMap = null;
    });
  }

  editMap(map: WidgetMap) {
    const modalRef = this.modal.open(EditMapModalComponent);
    modalRef.componentInstance.init(this.widget, map);
    modalRef.result.then(map => {
      this.mapAdded.emit(map);
    });
  }

  addMap() {
    const modalRef = this.modal.open(CreateMapModalComponent);
    modalRef.componentInstance.init(this.widget);
    modalRef.result.then(map => {
      console.log(map);
      this.mapAdded.emit(map);
    });
  }

  reorderMaps() {
    this.isEditingMaps = !this.isEditingMaps;
  }

}



// WEBPACK FOOTER //
// ./src/app/widgets/widget-detail/map-list/map-list.component.ts